// Copyright (c) 2018 Deere & Company

import React, {Component, PropTypes} from 'react';
import InformationRequestForm from './information-request-form';
import InformationRequestFormStruct from '../../state/information-request-form';
import InlineAlertBar from '../../../../shared/components/inline-alert-bar';
import PartRequestForm from './part-request-form';
import PartRequestFormStruct from '../../state/part-request-form';
import PartReturn from '@deere/cps-it.warranty-model-factory/lib/part-return';
import PictureRequestForm from './picture-request-form';
import PictureRequestFormStruct from '../../state/picture-request-form';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import {isEditableAndAccessible as isPartReturnEditableAndAccessible} from '../../services/is-editable-and-accessible';
import {noPartsReturned} from '../../services/return-status';

function handleCancelButtonClick() {

    this.actions.goToPreviousView();

}

function handleDirtyFormReset() {

    this.actions.setFormToPrestine();

}

function handlePartRequestCommentsChange(comments) {

    this.actions.updatePartRequestFormComments(comments);

}

function handlePartRequestCourierNameChange(courierName) {

    this.actions.updatePartRequestFormCourierName(courierName);

}

function handlePartRequestDispatchDateChange(dispatchDate) {

    this.actions.updatePartRequestFormDispatchDate(dispatchDate);

}

function handlePartRequestReturnStatusChange(returnStatusId) {

    const returnStatus = this.partReturn.allowedReturnStatuses.find(status => status.id === returnStatusId);

    this.actions.updatePartRequestFormReturnStatus(returnStatus);

}

function handlePartRequestSubmit() {

    this.actions.submitRequestForm(this.partRequestForm, this.partReturn);

}

function handlePartRequestTrackingNumberChange(trackingNumber) {

    this.actions.updatePartRequestFormTrackingNumber(trackingNumber);

}

function handleInfoRequestAnswerChange(answer, questionId, questions) {

    this.actions.updateInfoRequestFormAnswer(answer, questionId, questions);

}

function handleInfoRequestCommentsChange(comments) {

    this.actions.updateInfoRequestFormComments(comments);

}

function handleInfoRequestFileDelete(file) {

    this.actions.deleteInfoRequestFormFile(file, this.informationRequestForm.files);

}

function handleInfoRequestFileUploadSuccess(file, dropzone) {

    this.actions.addInfoRequestFormFile(JSON.parse(file.xhr.response));

    dropzone.removeFile(file);

}

function handleInfoRequestStatusChange(statusId) {

    const infoRequestStatus = this.partReturn.allowedReturnStatuses.find(status => status.id === statusId);

    this.actions.updateInfoRequestFormReturnStatus(infoRequestStatus);

}

function handleInfoRequestSubmit() {

    this.actions.submitRequestForm(this.informationRequestForm, this.partReturn);

}

function handlePictRequestCommentsChange(comments) {

    this.actions.updatePictRequestFormComments(comments);

}

function handlePictRequestFileDelete(file) {

    this.actions.deletePictRequestFormFile(file, this.pictureRequestForm.files);

}

function handlePictRequestFileUploadSuccess(file, dropzone) {

    this.actions.addPictRequestFormFile(JSON.parse(file.xhr.response));

    dropzone.removeFile(file);

}

function handlePictRequestStatusChange(statusId) {

    const pictRequestStatus = this.partReturn.allowedReturnStatuses.find(status => status.id === statusId);

    this.actions.updatePictRequestFormReturnStatus(pictRequestStatus);

}

function handlePictRequestSubmit() {

    this.actions.submitRequestForm(this.pictureRequestForm, this.partReturn);

}

class FormFieldsContainer extends Component {

    componentWillUnmount() {

        this.props::handleDirtyFormReset();

    }

    render() {

        const isEditableAndAccessible = isPartReturnEditableAndAccessible(this.props.partReturn, this.props.security);

        return (
            <div className='form-fields-container'>
                {this.props.partReturn.requestType.key === 'PART' && this.props.partRequestForm.returnStatus.id === noPartsReturned &&
                    <InlineAlertBar
                        label='FAILURE_TO_RETURN_PARTS_WARNING'
                        type='warning'
                    />
                }
                {this.props.partReturn.requestType.key === 'PART' &&
                    <PartRequestForm
                        isEditableAndAccessible={isEditableAndAccessible}
                        isFormDirty={this.props.isFormDirty}
                        onCancelButtonClick={this.props::handleCancelButtonClick}
                        onCommentsChange={this.props::handlePartRequestCommentsChange}
                        onCourierNameChange={this.props::handlePartRequestCourierNameChange}
                        onDispatchDateChange={this.props::handlePartRequestDispatchDateChange}
                        onPartReturnStatusChange={this.props::handlePartRequestReturnStatusChange}
                        onSubmitButtonClick={this.props::handlePartRequestSubmit}
                        onTrackingNumberChange={this.props::handlePartRequestTrackingNumberChange}
                        partRequestForm={this.props.partRequestForm}
                        partReturn={this.props.partReturn}
                    />
                }
                {this.props.partReturn.requestType.key === 'INFO' &&
                    <InformationRequestForm
                        informationRequestForm={this.props.informationRequestForm}
                        isEditableAndAccessible={isEditableAndAccessible}
                        isFormDirty={this.props.isFormDirty}
                        onAnswerChange={this.props::handleInfoRequestAnswerChange}
                        onCancelButtonClick={this.props::handleCancelButtonClick}
                        onCommentsChange={this.props::handleInfoRequestCommentsChange}
                        onFileDelete={this.props::handleInfoRequestFileDelete}
                        onFileUploadSuccess={this.props::handleInfoRequestFileUploadSuccess}
                        onInfoRequestStatusChange={this.props::handleInfoRequestStatusChange}
                        onSubmitButtonClick={this.props::handleInfoRequestSubmit}
                        partReturn={this.props.partReturn}
                    />
                }
                {this.props.partReturn.requestType.key === 'PICT' &&
                    <PictureRequestForm
                        isEditableAndAccessible={isEditableAndAccessible}
                        isFormDirty={this.props.isFormDirty}
                        onCancelButtonClick={this.props::handleCancelButtonClick}
                        onCommentsChange={this.props::handlePictRequestCommentsChange}
                        onFileDelete={this.props::handlePictRequestFileDelete}
                        onFileUploadSuccess={this.props::handlePictRequestFileUploadSuccess}
                        onPictRequestStatusChange={this.props::handlePictRequestStatusChange}
                        onSubmitButtonClick={this.props::handlePictRequestSubmit}
                        partReturn={this.props.partReturn}
                        pictureRequestForm={this.props.pictureRequestForm}
                    />
                }
            </div>
        );

    }

}

FormFieldsContainer.displayName = 'FormFieldsContainer';
FormFieldsContainer.propTypes = {
    actions: PropTypes.object.isRequired,
    informationRequestForm: PropTypes.instanceOf(InformationRequestFormStruct).isRequired,
    isFormDirty: PropTypes.bool.isRequired,
    partRequestForm: PropTypes.instanceOf(PartRequestFormStruct).isRequired,
    partReturn: PropTypes.instanceOf(PartReturn).isRequired,
    pictureRequestForm: PropTypes.instanceOf(PictureRequestFormStruct).isRequired,
    security: PropTypes.instanceOf(Security).isRequired
};

export default FormFieldsContainer;



// WEBPACK FOOTER //
// ./src/part-requests/request-details/components/form-fields/form-fields-container.js